import React from 'react';
import { Button } from './ui/Button';
import { Shield, Zap, CreditCard } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42804528906311:1';
export function LaunchOffer() {
  return <section className="py-12 md:py-20 px-4" data-id="element-238">
      <div className="max-w-3xl mx-auto bg-surface border-2 border-primary rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(249,168,212,0.12)]" data-id="element-239">
        <div className="inline-flex items-center gap-2 bg-primary/15 border border-primary/30 rounded-full px-3 py-1 text-[11px] font-bold text-primary uppercase tracking-wider mb-5" data-id="element-240">
          ⚡ Oferta de lanzamiento
        </div>

        <h2 className="text-2xl md:text-4xl font-extrabold mb-6 tracking-tight" data-id="element-241">
          Todo tu año de clases,{' '}
          <span className="text-primary" data-id="element-242">resuelto hoy</span>
        </h2>

        <div className="mb-8" data-id="element-243">
          <div className="text-zinc-500 line-through text-lg font-bold mb-1" data-id="element-244">
            Antes: $51.900
          </div>
          <div className="text-5xl md:text-6xl font-extrabold text-white" data-id="element-245">
            $19.990 <span className="text-2xl text-zinc-500" data-id="element-246">ARS</span>
          </div>
        </div>

        <Button href={URL_COMBO} className="text-lg md:text-xl py-5 px-10 w-full md:w-auto mb-6 shadow-[0_0_30px_rgba(249,168,212,0.3)]" data-id="element-247">
          QUIERO MI COMBO AHORA
        </Button>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-zinc-400 font-medium" data-id="element-248">
          <span className="flex items-center gap-1.5" data-id="element-249">
            <Shield className="w-4 h-4 text-primary" data-id="element-250" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-251">
            <Zap className="w-4 h-4 text-primary" data-id="element-252" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-253">
            <CreditCard className="w-4 h-4 text-primary" data-id="element-254" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}